import { render } from "./PopupCountDown.vue?vue&type=template&id=4da647be&scoped=true"
import script from "./PopupCountDown.vue?vue&type=script&lang=js"
export * from "./PopupCountDown.vue?vue&type=script&lang=js"

import "./PopupCountDown.vue?vue&type=style&index=0&id=4da647be&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da647be"]])

export default __exports__